/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_TemplateInputs */



/**
* | output |
* | --- |
* | "Download template" |
*
* @param {Team_Manager_Import_TemplateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_template = /** @type {((inputs?: Team_Manager_Import_TemplateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_TemplateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Télécharger le modèle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorlage herunterladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scarica modello")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скачать шаблон")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargar plantilla")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("下载模板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テンプレートをダウンロード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेम्पलेट डाउनलोड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transferir modelo")
	return /** @type {LocalizedString} */ ("Download template")
});